import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=74be4da8&scoped=true&"
import script from "./FormModal.vue?vue&type=script&lang=js&"
export * from "./FormModal.vue?vue&type=script&lang=js&"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=74be4da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be4da8",
  null
  
)

export default component.exports